module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAD6ADAAQAAAABAAAAEgAAAACfRog6AAAA/klEQVQ4EZ2Tuw4BQRSGN+JS6ASRiEIjEUspOq3CM2h4BbXeG/AGEi+goJaoJCqFSiJCKEVC+A5THJcdl5N8mXPOP//M7O6s47xGlFYH5rCHEVThY6SZsYYLLGAMB1O3GK0hu4ixoWalyKdwhqLqP6QxKjH2H7r3omS0ttZ8qiiYXI76HBMaJ8hrQZuDRjjqCSaXIwshrfkpMtCErBHqjGWT6yFA4UIPhtAFZwbyrL9SkWPn4J9w9TP/vIDNvGS1OOy8VrWZt5g2IFf0bdjMbw26aTPLjUtARBt0Lt/ZK5IIKy9R+radbb6bJmbPF/LBffPVmCSf49sbJj/IAMJXmHw+Oou3SlkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/login/password.png
// module id = SjXz
// module chunks = 6